import * as React from 'react'
import {ReactNode} from 'react'
import PPSelect, {OptionProps} from '../../../../shared/forms/PPSelect'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../../../CodeMaster'
import {Nullable} from '../../../../../app/TypeHelpers'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Box} from '@mui/material'
import {EndOfTimeZoneInputWithMaxTime} from './EndOfTimeZoneInputWithMaxTime'
import {calcSelectableHoursAndUpperLimit} from './helpers'
import {TimeZoneInputWithMaxTimeProps} from './TimeZoneInputWithMaxTime'
import equal from 'fast-deep-equal'
import {addEmptyData, isNoSelect, valueOrNoSelected} from '../../../../../componentHelper/selectHelper'
import {valueStringOrEmpty} from '../../../../../codeMasterHelper/CodeMasterHelper'
import {SelectChangeEvent} from '@mui/material/Select'

interface FirstLineTimeZoneWithMaxTimeProps {
    onChangeStartHour: (startHour: Nullable<HOURS>) => void
    onChangeMinute: (minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>) => void
    onChangeStartTime: (startHour: HOURS) => void
}

export class FirstLineTimeZoneWithMaxTime
    extends React.Component<FirstLineTimeZoneWithMaxTimeProps & TimeZoneInputWithMaxTimeProps> {

    constructor(props: Readonly<FirstLineTimeZoneWithMaxTimeProps & TimeZoneInputWithMaxTimeProps>) {
        super(props)

        this.handleChangeMinute = this.handleChangeMinute.bind(this)
        this.handleChangeStartHour = this.handleChangeStartHour.bind(this)
    }

    shouldComponentUpdate(
        nextProps: Readonly<FirstLineTimeZoneWithMaxTimeProps & TimeZoneInputWithMaxTimeProps>,
    ): boolean {
        return !(this.props === nextProps || equal(this.props, nextProps))
    }

    handleChangeStartHour(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === undefined) {
            return
        }
        const value: string = `${event.target.value}`
        if (isNoSelect(value)) {
            return
        }
        const newValue: HOURS = HOURS.codeToEnumConstants(value)

        if (this.props.minute === null) {
            this.props.onChangeStartHour(newValue)
        } else {
            this.props.onChangeStartTime(newValue)
        }
    }

    handleChangeMinute(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === undefined) {
            return
        }
        const value: string = `${event.target.value}`
        if (isNoSelect(value)) {
            return
        }
        this.props.onChangeMinute(RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(value))
        if (this.props.startHour !== null) {
            this.props.onChangeStartTime(this.props.startHour)
        }
    }

    getSelectableMinute(minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>): OptionProps[] {
        const options = RESERVATION_TIME_UNIT_MINUTES.values()
        return (minute === null) ? addEmptyData(options) : options
    }

    getFirstLineSelectableStartHours(startHour: Nullable<HOURS>): OptionProps[] {
        const options = HOURS.values()
        return (startHour === null) ? addEmptyData(options) : options
    }

    render(): ReactNode {
        const {startHour, endHour, minute, selectableEndHour, maxReservationTime} = this.props

        const startHourValue: string = valueOrNoSelected(startHour)
        const minuteValue: string = valueStringOrEmpty(minute)
        const isUnsetStartTime: boolean = (startHour === null || minute === null)
        const {maxReservationTimeUpperLimit, selectableHours} =
            calcSelectableHoursAndUpperLimit(startHour, endHour, selectableEndHour)

        return (
            <LeftRowFlexContainer>
                <Box display={'flex'} justifyContent="flex-end" minWidth={'72px'}>
                    <RowFlexContainer>
                        <label>
                            <RowFlexContainer>
                                <PPSelect
                                    required={true}
                                    data={this.getFirstLineSelectableStartHours(startHour)}
                                    value={startHourValue}
                                    disabled={!isUnsetStartTime}
                                    onChange={this.handleChangeStartHour}
                                />
                                時
                            </RowFlexContainer>
                        </label>
                    </RowFlexContainer>
                </Box>
                <Box display={'flex'} justifyContent="flex-end" minWidth={'72px'}>
                    <RowFlexContainer>
                        <label>
                            <RowFlexContainer>
                                <PPSelect
                                    required={true}
                                    data={this.getSelectableMinute(minute)}
                                    value={minuteValue}
                                    disabled={!isUnsetStartTime}
                                    onChange={this.handleChangeMinute}
                                />
                                分
                            </RowFlexContainer>
                        </label>
                    </RowFlexContainer>
                </Box>
                <Box display="flex" justifyContent="center" minWidth={'24px'}>
                    〜
                </Box>
                <EndOfTimeZoneInputWithMaxTime
                    hour={endHour}
                    minute={minute}
                    selectableHours={selectableHours}
                    maxReservationTime={maxReservationTime}
                    maxReservationTimeUpperLimit={maxReservationTimeUpperLimit}
                    onChangeEndHour={this.props.onChangeEndHour}
                    onChangeMaxTime={this.props.onChangeMaxTime}
                />
            </LeftRowFlexContainer>)
    }
}
